import React, { useState } from "react";
import { FiFilter, FiChevronDown, FiChevronUp } from "react-icons/fi";

function Filtersidebar({
  filterData,
  filters,
  onFilterChange,
  onCheckboxChange,
  priceRange,
  onPriceChange,
}) {
  const [showAllCategories, setShowAllCategories] = useState(false);
  const [showAllBrands, setShowAllBrands] = useState(false);

  return (
    <div className="filter-sidebar-minimal">
      <div className="filter-header-main">
        <FiFilter size={18} />
        <span>FILTERS</span>
      </div>

      {/* CATEGORY SECTION */}
      <div className="filter-group">
        <label className="filter-label-sticker">Category</label>
        <div className="filter-options-list">
          {(showAllCategories ? filterData?.categories : filterData?.categories?.slice(0, 6))?.map((cat) => (
            <div className="custom-checkbox-wrapper" key={cat._id}>
              <input
                type="checkbox"
                id={`cat-${cat._id}`}
                checked={filters.category.includes(cat._id)}
                onChange={() => onCheckboxChange("category", cat._id)}
              />
              <label htmlFor={`cat-${cat._id}`}>{cat.name}</label>
            </div>
          ))}
          {filterData?.categories?.length > 6 && (
            <button className="view-more-btn" onClick={() => setShowAllCategories(!showAllCategories)}>
              {showAllCategories ? <><FiChevronUp /> Less</> : <><FiChevronDown /> More</>}
            </button>
          )}
        </div>
      </div>

      {/* PRICE RANGE SECTION */}
      <div className="filter-group">
        <label className="filter-label-sticker">Price Range</label>
        <div className="price-slider-container">
          <div className="range-slider-minimal">
            <input
              type="range"
              min={filterData?.priceRange?.min || 0}
              max={filterData?.priceRange?.max || 1000}
              value={priceRange[0]}
              onChange={(e) => onPriceChange([Math.min(+e.target.value, priceRange[1] - 100), priceRange[1]])}
              className="thumb thumb-left"
            />
            <input
              type="range"
              min={filterData?.priceRange?.min || 0}
              max={filterData?.priceRange?.max || 10000}
              value={priceRange[1]}
              onChange={(e) => onPriceChange([priceRange[0], Math.max(+e.target.value, priceRange[0] + 100)])}
              className="thumb thumb-right"
            />
            <div className="slider-track-minimal" />
          </div>
          <div className="price-labels-flex">
            <span>₹{priceRange[0]}</span>
            <span>₹{priceRange[1]}+</span>
          </div>
        </div>
      </div>

      {/* SORT SECTION */}
      
    </div>
  );
}

export default Filtersidebar;